var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17157 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17157 8.5 10 8.5C10.8284 8.5 11.5 9.17157 11.5 10ZM12.9055 10.75C12.5725 12.0439 11.3979 13 10 13C8.34315 13 7 11.6569 7 10C7 8.34315 8.34315 7 10 7C11.3979 7 12.5725 7.95608 12.9055 9.25H24C24.4142 9.25 24.75 9.58579 24.75 10C24.75 10.4142 24.4142 10.75 24 10.75H12.9055Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.55 16.5C20.55 15.8096 21.1096 15.25 21.8 15.25C22.4903 15.25 23.05 15.8096 23.05 16.5C23.05 17.1904 22.4903 17.75 21.8 17.75C21.1096 17.75 20.55 17.1904 20.55 16.5ZM18.9296 15.625C19.3041 14.395 20.4475 13.5 21.8 13.5C23.4568 13.5 24.8 14.8431 24.8 16.5C24.8 18.1569 23.4568 19.5 21.8 19.5C20.4475 19.5 19.3041 18.605 18.9296 17.375L7.79999 17.375C7.31674 17.375 6.92499 16.9832 6.92499 16.5C6.92499 16.0167 7.31674 15.625 7.79999 15.625L18.9296 15.625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 23C11.5 23.8284 10.8284 24.5 10 24.5C9.17157 24.5 8.5 23.8284 8.5 23C8.5 22.1716 9.17157 21.5 10 21.5C10.8284 21.5 11.5 22.1716 11.5 23ZM12.9055 23.75C12.5725 25.0439 11.3979 26 10 26C8.34315 26 7 24.6569 7 23C7 21.3431 8.34315 20 10 20C11.3979 20 12.5725 20.9561 12.9055 22.25H24C24.4142 22.25 24.75 22.5858 24.75 23C24.75 23.4142 24.4142 23.75 24 23.75H12.9055Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e213e7d909f5ee2a9076ed715483797b.svg";
export { ForwardRef as ReactComponent };